import axiosInstance from '../axiosInterceptor/axiosInstance'

// { signatureRequired }: true only for the org's owner while a super admin has an open ask.
// Called on every layout mount, so a failing read must not flash a snackbar.
const getOrgContractStatus = (orgId) =>
  axiosInstance
    .get(`v1/orgs/${orgId}/contracts/status`, { skipErrorNotification: true })
    .then((r) => r.data)

export default getOrgContractStatus
